import { $ } from '@/libs/jquery/index'

import 'jquery-validation/dist/additional-methods'

import '@frontend/jquery-validation/dist/jquery.validate'

import '@/libs/jquery-validation/address'
import '@/libs/jquery-validation/birthday'
import '@/libs/jquery-validation/card-amount-digits'
import '@/libs/jquery-validation/card-expire'
import '@/libs/jquery-validation/card-expire-date'
import '@/libs/jquery-validation/citizenship'
import '@/libs/jquery-validation/date'
import '@/libs/jquery-validation/depends_all'
import '@/libs/jquery-validation/depends_from'
import '@/libs/jquery-validation/email'
import '@/libs/jquery-validation/is-child'
import '@/libs/jquery-validation/length'
import '@/libs/jquery-validation/only-letters'
import '@/libs/jquery-validation/passport-code'
import '@/libs/jquery-validation/passport-place-with-date'
import '@/libs/jquery-validation/phone'

$.extend($.validator.messages, {
  'accept': 'Please enter a value with a valid extension.',
  'address': 'Адрес заполнен некорректно',
  'birthday': 'Укажите верную дату рождения',
  'cardamountdigits': 'Некорректный формат номера карты',
  'cardexpiredate': 'Укажите верное значение',
  'cardexpiremonth': 'Укажите верное значение',
  'cardexpireyear': 'Укажите верное значение',
  'citizenship': 'Поле заполнено некорректно.',
  'creditcard': 'Укажите верный номер карты.',
  'date': 'Укажите верную дату',
  'dateISO': 'Please enter a valid date (ISO).',
  'dependsall': 'Поле, обязательное к заполнению.',
  'dependsfrom': 'Поле заполнено некорректно.',
  'digits': 'Укажите только цифры',
  'email': 'Укажите верный email',
  'equalTo': 'Please enter the same value again.',
  'inn': 'Укажите корректный номер ИНН',
  'ischild': 'Укажите верный возраст ребёнка',
  'length': 'Поле заполнено некорректно.',
  'max': $.validator.format('Please enter a value less than or equal to {0}.'),
  'maxlength': $.validator.format('Введите не более {0} символов.'),
  'min': $.validator.format('Введите число больше или равное {0}.'),
  'minlength': $.validator.format('Введите не менее {0} символов.'),
  'number': 'Please enter a valid number.',
  'onlyletters': 'Укажите верное значение',
  'passportPlaceWithCode': 'Некорректно заполнено поле, посмотрите пример заполнения',
  'passportcode': 'Укажите верный код подразделения',
  'pediatricianBDate': 'Возраст должен быть от 1 года до 17 лет',
  'phone': 'Укажите верный номер',
  'range': $.validator.format('Please enter a value between {0} and {1}.'),
  'rangelength': $.validator.format('Please enter a value between {0} and {1} characters long.'),
  'remote': 'Please fix this field.',
  'require-from-group': $.validator.format( 'Укажите не менее {0} пунктов.'),
  'required': 'Поле, обязательное к заполнению',
  'time': 'Пожалуйста, укажите корректное время в диапазоне от 00:00 до 23:59',
  'url': 'Укажите верную ссылку',
})
